export default __webpack_public_path__ + "static/media/searchbox.ec5d5b01.svg";